import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ icon, imagesrc, url, color }) => {
  return (
    <div className={`relative flex items-center justify-center rounded-full w-20 h-20 ${color}`}>
      {/* Link around the content */}
      <a href={url} target="_blank" rel="noopener noreferrer" className="absolute w-20 h-20 rounded-full flex items-center justify-center overflow-hidden">
        {/* Rotating border with scaling on load */}
        <motion.div
          className="absolute w-full h-full rounded-full border-l-4 border-gray-300"
          initial={{ scale: 0 }}  // Start with scale 0
          animate={{ rotate: [0, 360], scale: 1 }}  // Rotate and scale to 1
          transition={{
            rotate: {
              repeat: Infinity,   // Infinite loop for rotation
              duration: 2,        // Duration for one full rotation
              ease: "linear"      // Smooth and consistent speed
            },
            scale: {
              duration: 1,        // Duration for scaling animation
              ease: "easeOut"     // Smooth scaling effect
            }
          }}
          whileHover={{
            rotate: 0,          // On hover, set rotation to 0
            scale: 1            // Ensure scale remains 1 on hover
          }}
          whileHoverTransition={{
            ease: "easeInOut",
            duration: 2         // Duration for the hover transition
          }}
        />
        
        {/* Static inner content (icon or image) */}
        <motion.div
          className="w-full h-full rounded-full flex items-center justify-center overflow-hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1 }}
        >
          {imagesrc ? (
            <img
              src={imagesrc}
              alt="Button image"
              className="w-full h-full object-cover mt-4"
            />
          ) : (
            icon
          )}
        </motion.div>
      </a>
    </div>
  );
};

export default Button;
